import { __decorate } from "tslib";
import { AutoEncoder, field, IntegerDecoder, StringDecoder } from "@simonbackx/simple-encoding";
import { v4 as uuidv4 } from "uuid";
export class CheckoutCode extends AutoEncoder {
    constructor() {
        super(...arguments);
        this.code = "";
        this.amount = 0;
    }
}
__decorate([
    field({ decoder: StringDecoder, defaultValue: () => uuidv4() })
], CheckoutCode.prototype, "id", void 0);
__decorate([
    field({ decoder: StringDecoder })
], CheckoutCode.prototype, "code", void 0);
__decorate([
    field({ decoder: IntegerDecoder })
], CheckoutCode.prototype, "amount", void 0);
//# sourceMappingURL=CheckoutCode.js.map